module.exports = __webpack_public_path__ + "img/Newbie_Staff_04_Classic.0f285146.png";